"use strict";

require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteStart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _paulCorePackage = require("paul-core-package");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _reactRedux = require("react-redux");
var _images = require("../../images");
var _SiteStartPopUp = require("./SiteStartPopUp");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SiteStart = /*#__PURE__*/(0, _react.memo)(() => {
  const webpSupport = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getWebpSupport);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      minHeight: '100vh'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      height: '100vh',
      filter: 'blur(13px)'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    effect: "blur",
    src: _paulCorePackage.functions.getSupportedImg({
      webpSupport,
      imgSizeKey: _paulCorePackage.constants.imgSizeKeys.preview,
      defaultImg: {
        webp: _images.getStartPageBackground.webp,
        original: _images.getStartPageBackground.png
      }
    }),
    width: "100%",
    height: "100%",
    style: {
      objectFit: 'cover',
      pointerEvents: 'none'
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }, /*#__PURE__*/_react.default.createElement(_SiteStartPopUp.SiteStartPopUp, null)));
});
exports.SiteStart = SiteStart;